module.exports = __webpack_public_path__ + "assets/img/c8f096111192591dfde93ee2743d5cf8.png";